// Вспомогательные данные для компонента демо-формы стандартизации

export const QC_COMPLETE_MESSAGES = {
    0: {
        text: "Подходит для рассылки",
        isCorrect: true,
    },
    5: {
        text: "Рассылка под вопросом: нет квартиры",
        isCorrect: false,
    },
    7: {
        text: "Не годится для рассылки: иностранный",
        isCorrect: false,
    },
    8: {
        text: "Рассылка под вопросом: до почтового отделения",
        isCorrect: false,
    },
    9: {
        text: "Рассылка под вопросом: неуверенный разбор",
        isCorrect: false,
    },
    10: {
        text: "Рассылка под вопросом: дома нет в ФИАС",
        isCorrect: false,
    },
    default: {
        text: "Не годится для рассылки: адрес неполный",
        isCorrect: false,
    },
};

export const QC_MESSAGES = {
    address: {
        0: {
            text: "Не требует ручной проверки",
            isCorrect: true,
        },
        2: {
            text: "Пустой или мусорный",
            isCorrect: true,
        },
        default: {
            text: "На ручную проверку",
            isCorrect: false,
        },
    },
    name: {
        0: {
            text: "Не требует ручной проверки",
            isCorrect: true,
        },
        default: {
            text: "На ручную проверку",
            isCorrect: false,
        },
    },
    phone: {
        0: {
            text: "Не требует ручной проверки",
            isCorrect: true,
        },
        1: {
            text: "На ручную проверку",
            isCorrect: false,
        },
        2: {
            text: "Пустой или мусорный",
            isCorrect: false,
        },
        3: {
            text: "Несколько телефонов, распознан первый",
            isCorrect: false,
        },
        7: {
            text: "Иностранный",
            isCorrect: true,
        },
    },
    email: {
        0: {
            text: "Корректный адрес",
            isCorrect: true,
        },
        1: {
            text: "На ручную проверку",
            isCorrect: false,
        },
        2: {
            text: "Пустой или мусорный",
            isCorrect: false,
        },
        3: {
            text: "Одноразовый адрес",
            isCorrect: false,
        },
        4: {
            text: "Исправлены опечатки",
            isCorrect: true,
        },
    },
    passport: {
        0: {
            text: "Действующий паспорт",
            isCorrect: true,
        },
        1: {
            text: "На ручную проверку",
            isCorrect: false,
        },
        2: {
            text: "Пустой или мусорный",
            isCorrect: false,
        },
        10: {
            text: "Недействительный паспорт",
            isCorrect: false,
        },
    },
    vehicle: {
        1: {
            text: "На ручную проверку",
            isCorrect: false,
        },
        2: {
            text: "Пустой или мусорный",
            isCorrect: false,
        },
    },
};

export const optionsData = [
    {
        id: "address",
        text: "Адрес",
        label: "Адрес в свободной форме",
        defaultValue: "мск сухонска 11/-89",

        result: {
            source: "мск сухонска 11/-89",
            result: "г Москва, ул Сухонская, д 11, кв 89",
            postal_code: "127642",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: "Центральный",
            region_fias_id: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
            region_kladr_id: "7700000000000",
            region_iso_code: "RU-MOW",
            region_with_type: "г Москва",
            region_type: "г",
            region_type_full: "город",
            region: "Москва",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: null,
            city_kladr_id: null,
            city_with_type: null,
            city_type: null,
            city_type_full: null,
            city: null,
            city_area: "Северо-восточный",
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: "р-н Северное Медведково",
            city_district_type: "р-н",
            city_district_type_full: "район",
            city_district: "Северное Медведково",
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: "95dbf7fb-0dd4-4a04-8100-4f6c847564b5",
            street_kladr_id: "77000000000283600",
            street_with_type: "ул Сухонская",
            street_type: "ул",
            street_type_full: "улица",
            street: "Сухонская",
            stead_fias_id: null,
            stead_kladr_id: null,
            stead_with_type: null,
            stead_type: null,
            stead_type_full: null,
            stead: null,
            house_fias_id: "5ee84ac0-eb9a-4b42-b814-2f5f7c27c255",
            house_kladr_id: "7700000000028360004",
            house_cadnum: null,
            house_type: "д",
            house_type_full: "дом",
            house: "11",
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: "f26b876b-6857-4951-b060-ec6559f04a9a",
            flat_cadnum: "77:02:0004008:4143",
            flat_type: "кв",
            flat_type_full: "квартира",
            flat: "89",
            flat_area: "34.6",
            square_meter_price: "208738",
            flat_price: "7222335",
            postal_box: null,
            fias_id: "f26b876b-6857-4951-b060-ec6559f04a9a",
            fias_code: null,
            fias_level: "9",
            fias_actuality_state: "0",
            kladr_id: "7700000000028360004",
            capital_marker: "0",
            okato: "45280583000",
            oktmo: "45362000",
            tax_office: "7715",
            tax_office_legal: "7715",
            timezone: "UTC+3",
            geo_lat: "55.8782557",
            geo_lon: "37.65372",
            beltway_hit: "IN_MKAD",
            beltway_distance: null,
            qc_geo: 0,
            qc_complete: 0,
            qc_house: 2,
            qc: 0,
            unparsed_parts: null,
            metro: [
                {
                    distance: 1.1,
                    line: "Калужско-Рижская",
                    name: "Бабушкинская",
                },
                {
                    distance: 1.2,
                    line: "Калужско-Рижская",
                    name: "Медведково",
                },
                {
                    distance: 2.5,
                    line: "Калужско-Рижская",
                    name: "Свиблово",
                },
            ],
            delivery: {
                boxberry_id: "68",
                cdek_id: "44",
                dpd_id: "49694102",
            },
        },

        qcMessage: QC_MESSAGES.address[0],
        qcCompleteMessage: QC_COMPLETE_MESSAGES[0],
    },
    {
        id: "name",
        text: "ФИО",
        label: "ФИО в свободной форме",
        defaultValue: "Срегей владимерович иванов",

        result: {
            source: "Срегей владимерович иванов",
            result: "Иванов Сергей Владимирович",
            result_genitive: "Иванова Сергея Владимировича",
            result_dative: "Иванову Сергею Владимировичу",
            result_ablative: "Ивановым Сергеем Владимировичем",
            surname: "Иванов",
            name: "Сергей",
            patronymic: "Владимирович",
            gender: "М",
            qc: 1,
        },

        qcMessage: QC_MESSAGES.name.default,
        qcCompleteMessage: null,
    },
    {
        id: "phone",
        text: "Телефон",
        label: "Номер телефона в свободной форме",
        defaultValue: "раб 846)231.60.14 *139",

        result: {
            source: "раб 846)231.60.14 *139",
            type: "Стационарный",
            phone: "+7 846 231-60-14 доб. 139",
            country_code: "7",
            city_code: "846",
            number: "2316014",
            extension: "139",
            provider: "ООО \"СИПАУТНЭТ\"",
            country: "Россия",
            region: "Самарская область",
            city: "Самара",
            timezone: "UTC+4",
            qc_conflict: 0,
            qc: 0,
        },

        qcMessage: QC_MESSAGES.phone[0],
        qcCompleteMessage: null,
    },
    {
        id: "email",
        text: "Email",
        label: "Адрес электронной почты",
        defaultValue: "serega@yandex/ru",

        result: {
            source: "serega@yandex/ru",
            email: "serega@yandex.ru",
            local: "serega",
            domain: "yandex.ru",
            type: "PERSONAL",
            qc: 4,
            suggestions: [
                {
                    value: "serega@yandex.ru",
                    unrestricted_value: "serega@yandex.ru",
                    data: {
                        email: {
                            local: "serega",
                            domain: "yandex.ru",
                            type: "PERSONAL",
                            source: "serega@yandex.ru",
                            qc: null,
                        },
                        company: null,
                    },
                },
            ],

        },

        qcMessage: QC_MESSAGES.email[4],
        qcCompleteMessage: null,
    },
    {
        id: "passport",
        text: "Паспорт",
        label: "Серия и номер паспорта",
        defaultValue: "4509 235857",

        result: {
            source: "4509 235857",
            series: "45 09",
            number: "235857",
            qc: 0,
        },

        qcMessage: QC_MESSAGES.passport[0],
        qcCompleteMessage: null,
    },
    {
        id: "vehicle",
        text: "Автомобиль",
        label: "Марка и модель автомобиля",
        defaultValue: "ЦРВ Хонда",

        result: {
            source: "ЦРВ Хонда",
            brand: "Honda",
            model: "CR-V",
            qc: 0,
        },

        qcMessage: QC_MESSAGES.vehicle[0],
        qcCompleteMessage: null,
    },
];

export default {
    QC_COMPLETE_MESSAGES,
    QC_MESSAGES,
    optionsData,
};
